import { createContext } from "react";

interface NavbarContextValue {
  $bs_navbar?: {
    bsClass?: string;
    onSelect?: (key: any) => void;
  };
}

const NavbarContext = createContext<NavbarContextValue>({});

export default NavbarContext;
